import moment from "moment";
import { FcApproval } from "react-icons/fc";

export function isEmpty(obj) {
  let isEmpty = false;
  const type = typeof obj;
  isEmpty = isEmpty || !obj;
  isEmpty = isEmpty || type === "undefined"; // if it is undefined
  isEmpty = isEmpty || obj === null; // if it is null
  isEmpty = isEmpty || (type === "string" && obj === ""); // if the string is empty
  isEmpty = isEmpty || obj === false || obj === 0; // if boolean value returns false
  isEmpty = isEmpty || (Array.isArray(obj) && obj.length === 0); // if array is empty
  isEmpty = isEmpty || (type === "object" && Object.keys(obj).length === 0); // if object is empty
  return isEmpty;
}

export const checkDevice = (req) => {
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return Boolean(
    userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    )
  );
};

export function isDateExpired(expiryDate) {
  const expiryMoment = moment(expiryDate, "DD/MM/YYYY");
  const currentMoment = moment();
  // return currentMoment.isAfter(expiryMoment, "day");
  return false;
}

export const getColor = (_name) => {
  const name = _name.toUpperCase();

  // If '|' is found, split the text and return an anchor tag
  if (name.includes("|")) {
    const [text, link] = name.split("|");
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {text.toLowerCase()}
      </a>
    );
  }

  switch (name) {
    case "JANUARY":
    case "FEBRUARY":
    case "MARCH":
    case "APRIL":
    case "MAY":
    case "JUNE":
    case "JULY":
    case "AUGUST":
    case "SEPTEMBER":
    case "OCTOBER":
    case "NOVEMBER":
    case "DECEMBER":
      return (
        <div className="month-chips">
          <FcApproval /> &nbsp;{name}
        </div>
      );
    default:
      return name.toLowerCase();
  }
};
